import * as tslib_1 from "tslib";
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormlyValidationMessages } from '../../core';
var FormlyValidationMessage = (function () {
    function FormlyValidationMessage(formlyMessages) {
        this.formlyMessages = formlyMessages;
    }
    Object.defineProperty(FormlyValidationMessage.prototype, "errorMessage", {
        get: function () {
            for (var error in this.fieldForm.errors) {
                if (this.fieldForm.errors.hasOwnProperty(error)) {
                    var message = this.formlyMessages.getValidatorErrorMessage(error);
                    if (this.field.validation && this.field.validation.messages && this.field.validation.messages[error]) {
                        message = this.field.validation.messages[error];
                    }
                    if (this.field.validators && this.field.validators[error] && this.field.validators[error].message) {
                        message = this.field.validators[error].message;
                    }
                    if (this.field.asyncValidators && this.field.asyncValidators[error] && this.field.asyncValidators[error].message) {
                        message = this.field.asyncValidators[error].message;
                    }
                    if (typeof message === 'function') {
                        return message(this.fieldForm.errors[error], this.field);
                    }
                    return message;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    return FormlyValidationMessage;
}());
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", FormControl)
], FormlyValidationMessage.prototype, "fieldForm", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], FormlyValidationMessage.prototype, "field", void 0);
FormlyValidationMessage = tslib_1.__decorate([
    Component({
        selector: 'formly-validation-message',
        template: "{{ errorMessage }}",
    }),
    tslib_1.__metadata("design:paramtypes", [FormlyValidationMessages])
], FormlyValidationMessage);
export { FormlyValidationMessage };
//# sourceMappingURL=formly.validation-message.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/formly.validation-message.js
// module id = 328
// module chunks = 3